import '../typography/Text.js';
import '../typography/Display.js';
import '../typography/Heading.js';
import { Label } from '../typography/Label.js';
import '../typography/Paragraph.js';
import styled from 'styled-components';
var TableHeadCell = styled(Label)({
  wordBreak: "break-word",
  flexGrow: 1,
  flexBasis: 0,
  minWidth: "100px"
});
TableHeadCell.defaultProps = {
  padding: "10px",
  margin: "unset",
  size: "sm",
  weight: "heavy"
};
export { TableHeadCell };